export default "__VITE_ASSET__3fcff043__"